import React from "react";
import { Layout } from "../../layouts/Layout";
import {
  COMPANY,
  PRIVACY_POLICY,
  PRIVACY_SECTIONS,
} from "../../content/siteContent";
import { ContactNumbers } from "../../components/ContactNumbers/ContactNumbers";

const PrivacyPolicyPage = () => {
  return (
    <Layout
      breadcrumb={"Privacy Policy"}
      title={"Privacy Policy"}
      seo={{
        description:
          "Read the privacy policy for Zawix Business Consultants regarding website inquiries, contact forms, personal information, and service-related data handling.",
      }}
    >
      <section className="services-details-area pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="services-details-content">
                <div className="mb-40">
                  <p>
                    <strong>Effective Date:</strong> {PRIVACY_POLICY.effectiveDate}
                  </p>
                  <p>
                    <strong>Last Updated:</strong> {PRIVACY_POLICY.lastUpdated}
                  </p>
                  <p>{PRIVACY_POLICY.introduction}</p>
                </div>

                {PRIVACY_SECTIONS.map(([title, ...paragraphs]) => (
                  <div key={title} className="mb-40">
                    <h4 className="title-two">{title}</h4>
                    {paragraphs.map((paragraph, index) => (
                      <p key={`${title}-${index}`}>{paragraph}</p>
                    ))}
                  </div>
                ))}

                <div className="company-benefit-wrap">
                  <h4 className="title-two">{COMPANY.name}</h4>
                  <p>{COMPANY.fullAddress}</p>
                  <p>Email: {COMPANY.email}</p>
                  <ContactNumbers />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyPolicyPage;
